import { useSiteMetadata } from 'hooks/use-site-metadata';
import { useEffect } from 'react';
import { canUseDOM } from 'utils/helpers';

/*
  NOTE: The goal of this hook is to offer an alternative to pages
  where using the Gatsby Head API is not an option.
*/

const usePageTitle = (title: string) => {
  const siteMetadata = useSiteMetadata();
  const documentTitle = `${title} | ${siteMetadata?.title}`;

  useEffect(() => {
    // Checks if hooks is running on a browser
    if (!canUseDOM) return;

    // Add page title
    document.title = title ? documentTitle : '';

    return () => {
      /* Remove title tag when unmounting component */
      document.querySelector('title')?.remove();
    };
  }, [title, documentTitle]);

  return { title, documentTitle };
};

export default usePageTitle;
